import {useLocation} from "react-router-dom";

function useHash() {
    const location = useLocation();

    return location.hash.slice(1);
}

export default useHash;